import { ImmutableObject } from "../../../../shared/immutableObject";
import { WebSettings } from "./webSettings"

export class WebSettingsResponse extends ImmutableObject {

  protected readonly SETTINGS = "settings";
    
  get settings(): WebSettings { return this.getInternalValue<WebSettings>(this.SETTINGS); }
  setSettings(settings: WebSettings): this { return this.setInternalValue(this.SETTINGS, settings); }  
}